__turbopack_context__.v({
  "container": "SubscribeCta-module-scss-module__DOmIdG__container",
  "description": "SubscribeCta-module-scss-module__DOmIdG__description",
  "form": "SubscribeCta-module-scss-module__DOmIdG__form",
  "illustration": "SubscribeCta-module-scss-module__DOmIdG__illustration",
  "title": "SubscribeCta-module-scss-module__DOmIdG__title",
  "withImage": "SubscribeCta-module-scss-module__DOmIdG__withImage",
  "wrapper": "SubscribeCta-module-scss-module__DOmIdG__wrapper",
});
